/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types'
import { roundFloat } from 'helpers/helpers';


const CorredorEndosoSummary = ({ data, columns }) => {

  if (!data) {
    return null;
  }

  return (
    <table className="table table-striped" style={{ border: '1px solid #CCCCCC' }}>
      <thead>
        <tr className="text-center table-header">
          {columns.map(col => (
            <th key={col.title} scope="col" className={`text-${col.titleAlign || 'center'}`}>
              {col.title}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((row, rowIndex) => (
          <tr key={`row-${rowIndex}`} className="table-cell">
            {columns.map((col, colIndex) => (
              <td key={`col-${rowIndex}-${colIndex}`} className={`text-${col.cellAlign || 'center'}`}>
                {col.format === 'number' ? roundFloat(row[col.accessor]) : row[col.accessor]}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  )
};

CorredorEndosoSummary.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.array,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      accessor: PropTypes.string,
      titleAlign: PropTypes.string,
      cellAlign: PropTypes.string,
    }),
  ).isRequired,
};

CorredorEndosoSummary.defaultProps = {
  data: null,
};

export default CorredorEndosoSummary;
